export default __webpack_public_path__ + "static/media/9.46b613d2.svg";